import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Statistic, Table } from "antd";
import { CustomSpinner } from "../utils/CustomComponents";

const { Text } = Typography;

const FranchiseSellerMonthMaterial = ({ month, sellerId, plant }) => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(true);
	const [jobList, setJobList] = useState([]);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Material",
			dataIndex: "material",
			key: "material",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Quantity",
			dataIndex: "quantity",
			key: "quantity",
			render: (value) => {
				return (
					<Statistic
						value={value}
						precision={2}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
	];

	useEffect(() => {
		getJobs();
	}, []);

	const getJobs = async () => {
		try {
			setLoading(true);
			const url =
				api +
				`/job/seller/material?month=${month}&seller=${sellerId}&plant=${plant}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			let obj = {};

			data.payload.map((item) => {
				if (item.aggregates !== null) {
					item.aggregates.cogs.map((cog) => {
						if (!obj[`${cog.cog.material}`]) {
							obj[`${cog.cog.material}`] = {
								quantity: cog.quantity * item.targetYD3,
							};
						} else {
							obj[`${cog.cog.material}`].quantity +=
								cog.quantity * item.targetYD3;
						}
					});
				}
			});

			let list = Object.entries(obj).map(([key, value]) => {
				return {
					material: key,
					quantity: value.quantity,
				};
			});

			setJobList(list);
			setLoading(false);
			setLoadingTable(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={columns}
					dataSource={jobList}
					loading={loadingTable}
					pagination={false}
				/>
			</Flex>
		);
	};

	return (
		<Flex vertical gap={"large"}>
			{loading ? <CustomSpinner /> : <RenderTable />}
		</Flex>
	);
};

export default FranchiseSellerMonthMaterial;
